import axios from "axios";
import {HttpProtocolPrefix, RemoteControlProxy} from "../../../../settings";

export const rcApiClient = axios.create({
  baseURL: `${HttpProtocolPrefix}://${RemoteControlProxy}`,
});
rcApiClient.defaults.headers.common["accept-language"] = "locale";
